import { VariantProps, cva } from "class-variance-authority";
import { useMemo } from "react";
import { ImageWrapper, Link } from "ui-components";

import { Slider } from "../slider/Slider";

interface IPartners {
  [key: string]: string;
}
interface IMediaPartnersSliderProps
  extends VariantProps<typeof sectionClasses> {
  partners: IPartners;
  slidesToShow?: number;
}

export function MediaPartners({
  partners,
  slidesToShow = 5,
}: IMediaPartnersSliderProps): JSX.Element {
  const settings = {
    dots: false,
    infinite: Object.keys(partners).length > 1,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: slidesToShow > 1 ? 2 : slidesToShow,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderItems = useMemo(
    () =>
      Object.entries(partners).map(([key, value]) => (
        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-2.5" key={key}>
          <Link href="/organizations" className="focus:outline-none">
            <ImageWrapper
              src={value}
              width={50}
              layout="responsive"
              alt={value}
              height={50}
            />
          </Link>
        </div>
      )),
    [partners]
  );

  return <Slider settings={settings}>{renderItems}</Slider>;
}

const sectionClasses = cva("flex flex-col w-full", {
  variants: {
    spacing: {
      large: "gap-y-5 lg:gap-y-10",
      small: "gap-y-5",
    },
  },

  defaultVariants: {
    spacing: "large",
  },
});
